<div [class]="theme">
  <span class="themeSelect">
    <h1 class="themeSelect"></h1>
  </span>
</div>
